module.exports = __webpack_public_path__ + "static/media/gallery-24.9bb7a426.jpg";